import {
  GET_CITY_ERROR,
  GET_CITY_REQUEST,
  GET_CITY_SUCCESS,
  ADD_CITY_ERROR,
  ADD_CITY_REQUEST,
  ADD_CITY_SUCCESS,
  UPDATE_CITY_ERROR,
  UPDATE_CITY_REQUEST,
  UPDATE_CITY_SUCCESS,
  DELETE_CITY_ERROR,
  DELETE_CITY_REQUEST,
  DELETE_CITY_SUCCESS,
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CITY_REQUEST:
      return {
        loading: true,
      };
    case GET_CITY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_CITY_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    case ADD_CITY_REQUEST:
      return {
        loading: true,
      };
    case ADD_CITY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };
    case ADD_CITY_ERROR:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CITY_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CITY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };
    case UPDATE_CITY_ERROR:
      return {
        ...state,
        loading: false,
      };
    case DELETE_CITY_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CITY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };
    case DELETE_CITY_ERROR:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
